export const InheritedIRATriageContent = {
  pageTitle: `Open an inherited IRA`,
  pageDescription: `By submitting this request, you’ll be opening an inherited IRA to receive assets from a trust or estate disbursement.`,
  clientRadioQuestion: `Are you a Vanguard client?`,
  radioButtonHintError: `Make a selection to continue`,
  continueButton: 'Continue',
};
